import { MetricCard } from "./metric-card";
import { computeTrend } from "@/lib/metrics/trend";
import { formatInr } from "@/lib/format/inr";
import type { DashboardMetrics } from "@/lib/metrics/dashboard-metrics";

export interface MetricStripProps {
  metrics: DashboardMetrics;
}

export function MetricStrip({ metrics }: MetricStripProps) {
  return (
    <div className="grid grid-cols-5 gap-3">
      <MetricCard
        label="Total users"
        value={metrics.totalUsers}
        trend={computeTrend(metrics.signupsThisWeek, metrics.newUsersLastWeek)}
      />
      <MetricCard label="Active today" value={metrics.activeToday} />
      <MetricCard label="Groups" value={metrics.nonPersonalGroups} />
      <MetricCard
        label="Expenses today"
        value={metrics.expensesToday}
        trend={computeTrend(metrics.expensesToday, metrics.expensesYesterday)}
      />
      <MetricCard
        label="Amount · MTD"
        value={formatInr(metrics.amountThisMonth)}
      />
    </div>
  );
}
